"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mentionRegex = void 0;
var emailRegex = "[^\\s@]+@(?:[^\\s@]+(?:\\.(?:[^\\s@]+)?)?)?";
var userRegex = "[^@,.;]*";
var beginningRegex = "^|\\s";
exports.mentionRegex = new RegExp("(?:".concat(beginningRegex, ")(@(((?:").concat(emailRegex, ")|(?:").concat(userRegex, "))))$"));
